export default __webpack_public_path__ + "assets/madagascar-flag.png";